import Resource from "../../Entity/Resource";
import DocumentResource from "../../Entity/DocumentResource";
import DownloadManager from "../../Entity/DownloadManager";
import Document from "../../Entity/Document";

export default class CreateDownloadRequest {
    public constructor(
        private readonly resource: Resource,
        private readonly downloadManager: DownloadManager,
        private readonly documentResource: DocumentResource[],
        private readonly documents: Document[],
    ) {
    }

    public getResource(): Resource {
        return this.resource;
    }

    public getDownloadManager(): DownloadManager {
        return this.downloadManager;
    }

    public getDocumentResources(): DocumentResource[] {
        return this.documentResource;
    }

    public getDocuments(): Document[] {
        return this.documents;
    }
}